import { z } from 'zod';
import { TerrainType } from "../hex/types.js";
export const StatPointsSchema = z.object({
    min: z.number().int(),
    max: z.number().int(),
    points: z.number().int()
});
export const CharacterCreationConfigSchema = z.object({
    questions: z.array(z.object({ question: z.string(), defaultAnswers: z.array(z.string()) })),
    attributes: StatPointsSchema,
    skills: StatPointsSchema
});
export const ResourceIconSchema = z.object({
    atlas: z.string(),
    frame: z.string(),
});
export const GameConfigSchema = z.object({
    movementCosts: z.record(z.nativeEnum(TerrainType), z.number().int()),
    movementPointsPerDay: z.number().int().min(1),
    maxDays: z.number().int().min(1),
    innCost: z.number().int().min(0),
    inventoryCapacity: z.number().int().min(0),
    resourceIcons: z.object({
        gold: ResourceIconSchema,
        food: ResourceIconSchema,
    }),
    equipmentAtlases: z.array(z.string()),
});
